export default "__VITE_ASSET__Bljc8kmT__"